import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import Modal from "@mui/material/Modal";
import { useHistory } from "react-router-dom";
import {
  Select,
  MenuItem,
  Typography,
  Grid,
  Autocomplete,
  List,
  ListItem,
  TextField,
  useMediaQuery,
  Box,
  CircularProgress
} from "@mui/material";
import { useTheme } from '@mui/material/styles';

import AppContext from "../context/AppContext";
import { object } from "prop-types";

const AssetGraph = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const history = useHistory()
  const [openModal, setOpenModal] = useState(false);
  const [deviceid, setDeviceId] = useState(false);
  const [data, setUpdatedModalData] = useState([]);
  // const [selected, setSelected] = useState({});
  const [searchData, setSeearchData] = useState(null);
  const [asset, setTotalAsset] = useState(0)
  const [statuss, setStatus] = useState({})
  const [statussMoko, setStatusMoko] = useState({})
  const [gatewaystatus, setGatewayStatus] = useState({})
  const [strength, setStrength] = useState({})
  let values = useRef({})
  let resultStatus = {}

  useEffect(() => {
    let selectedData = Object.values(props.selected);

    const totalAsset = selectedData.reduce((acc, innerArray) => {
      return acc + innerArray.reduce((innerAcc, obj) => {
        return innerAcc + obj.connected_assets.length;
      }, 0);
    }, 0);
    setTotalAsset(totalAsset)

    fetchStatus()

  }, [props.selected])

  useEffect(() => {

    const fetchStatus = async () => {

      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/v1/beacon/get/gateway_logs/latest`)

        if (response.data.status == 'success') {
          setGatewayStatus(response.data.gateway_logs)
        }
      }
      catch (err) {
        console.log(err);
      }

    }

    fetchStatus()

  }, [])


  const fetchStatus = async () => {

    try {
      // const response = await axios.get(`${process.env.REACT_APP_URL}/api/v1/beacon/device/status?device_id=${device_id}`);

      const response = await axios.get(`${process.env.REACT_APP_URL}/api/v1/beacon/device/status/updated`);
      setStatus(response.data)
    }
    catch (err) {
      console.log(err);
    }

  }

  useEffect(() => {

    const fetchStatusMoko = async () => {

      try {

        const response = await axios.get(`${process.env.REACT_APP_URL}/api/v1/beacon/device/status/moko`);
        setStatusMoko(response.data)
      }
      catch (err) {
        console.log(err);
      }

    }

    fetchStatusMoko()

  }, [])



  const columns = [
    {
      field: "asset_name",
      headerName: "Asset Name",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Asset Name "}</strong>
      ),
      sortable: false,
      disableSelectionOnClick: true,
    },

    {
      field: "mac_id",
      headerName: "MAC ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"MAC ID "}</strong>
      ),
    },
    {
      field: "rssi",
      headerName: "RSSI",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"RSSI "}</strong>
      ),
    },
    {
      field: "latest_timestamp",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Timestamp "}</strong>
      ),
    },
  ];

  const handleCloseModal = () => {
    setSeearchData("");
    setUpdatedModalData([])
    setOpenModal(false);
  };

  const handleBeaconModal = (BeaconData, device_id) => {

    const newBeaconDataFormat = [];

    BeaconData.map((entry) => {
      newBeaconDataFormat.push({
        ...entry,
        latest_timestamp: new Date(new Date(entry.latest_timestamp).getTime()).toLocaleString()
      })
    })

    setUpdatedModalData(newBeaconDataFormat)
    setDeviceId(device_id)
    setOpenModal(true);
  }

  //  useEffect(()=> {

  //   const fetchData = async () => {
  //       try{


  //          data.forEach(row => {
  //           const {  mac_id } = row;

  //           // const response =  await axios.get(`${process.env.REACT_APP_URL}/api/v1/get/beacon/strength/comparision?mac=${mac}&device_id=${device_id}`)
  //           axios.get(`${process.env.REACT_APP_URL}/api/v1/get/beacon/strength/comparision?mac=${mac_id}&device_id=${deviceid}`)
  //           .then(response => {
  //             console.log(`API response for MAC ID ${mac_id}:`, response.data);
  //           })
  //           .catch(error => {
  //             console.error(`Error making API call for MAC ID ${mac_id}:`, error);
  //           });
  //         });

  //       }
  //       catch(err){
  //             console.log(err);
  //       }
  //   }

  //   fetchData()

  //  },[data])

  //  useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       for (let row of data) {
  //         const { mac_id } = row;

  //         try {
  //           const response = await axios.get(
  //             `${process.env.REACT_APP_URL}/api/v1/get/beacon/strength/comparision?mac=${mac_id}&device_id=${deviceid}`
  //           );
  //           console.log(`API response for MAC ID ${mac_id}:`, response.data.mac_address,response.data.color);

  //           setStrength({...strength , [response.data.mac_address]: response.data.color})


  //         } catch (error) {
  //           console.error(`Error making API call for MAC ID ${mac_id}:`, error);
  //         }
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };

  //   fetchData();
  // }, [data]);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const requests = data.map((row) => {
          const { mac_id } = row;
          return axios.get(
            `${process.env.REACT_APP_URL}/api/v1/get/beacon/strength/comparision?mac=${mac_id}&device_id=${deviceid}`
          );
        });

        const responses = await Promise.all(requests);

        if (mounted) {
          const newStrength = responses.reduce((acc, response) => {
            console.log(response.data);

            acc[response.data.mac_address] = response.data.color;
            return acc;
          }, {});

          setStrength((prevStrength) => ({
            ...prevStrength,
            ...newStrength,
          }));
        }
      } catch (error) {
        console.error('Error making API calls:', error);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [data, deviceid]);

  const getRowStyle = (color) => ({
    backgroundColor: color || 'transparent', // Fallback to transparent if no color found
  });


  return (

    <>
      {
        Object.values(props.selected).length ?
          <div>
            <Grid container spacing={2} alignItems="center">

            </Grid>
            <Grid container spacing={1} marginTop={2} paddingLeft={6} boxShadow='0px 2px 10.2px 1px rgba(0, 0, 0, 0.2)' borderRadius={'5px'} >
              {/* <Grid item xs={12}>
                <Typography variant="h7" fontSize={22} fontWeight={500} style={{ color: "#07689f" }}>Total Connected Asset:  {asset}</Typography>
              </Grid> */}
              <Grid item xs={12} style={{ maxHeight: '80vh', overflowY: 'auto', paddingRight: 10 }}>
                {
                  Object.values(props.selected)?.map((location, index) => {
                    return (
                      <Grid container key={index}>
                        <Grid item xs={12}>
                          {
                            location?.length > 0 && (
                              <Typography variant="h6" fontSize={22} fontWeight={500} style={{ color: "#07689f" }}>
                                {location[0]?.name}
                              </Typography>
                            )
                          }
                        </Grid>

                        {/* Horizontal scroll wrapper */}
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            flexDirection={isMobile ? 'column' : 'row'}
                            gap={isMobile ? 2 : '2rem'}
                            overflow="auto"
                            style={{ padding: '10px 0' }}
                          >
                            {
                              location?.map((gateway, gwIndex) => (
                                <Box key={gwIndex} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                                  <Box
                                    style={{
                                      backgroundColor: '#F5FCFF',
                                      padding: '5px 15px',
                                      borderRadius: 25,
                                      border: '0.5px solid #126881',
                                      margin: 21,
                                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                                    }}
                                  >
                                    <Typography fontSize={13} fontWeight="bold">Gateway ID: {gateway?.id}</Typography>
                                  </Box>

                                  <Box
                                    style={{
                                      padding: '12px 10px 20px 10px',
                                      backgroundColor: gateway.owner === 'Moko'
                                        ? (statussMoko[gateway.device_id]?.status === 'online' ? 'rgb(168 210 168 / 52%)' : 'rgb(128 128 128 / 37%)')
                                        : (statuss[gateway.device_id]?.status === 'online' ? 'rgb(168 210 168 / 52%)' : 'rgb(128 128 128 / 37%)'),
                                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                                      borderRadius: 13,
                                      marginBottom: 22,
                                      minWidth: isMobile ? '100%' : 240,
                                    }}
                                  >
                                    <p style={{ fontSize: 12, color: '#0d3152' }}>
                                      <strong>IMEI No:</strong>{' '}
                                      <span
                                        style={{ cursor: "pointer", fontWeight: 500, textDecoration: "underline", color: 'green', fontSize: '14px' }}
                                        onClick={() => history.push(`/reports/gateway-id/${gateway.device_id}`)}
                                      >
                                        {gateway.device_id || 'NA'}
                                      </span>
                                    </p>
                                    <p style={{ fontSize: 12, color: '#0d3152' }}>
                                      <strong>Make:</strong> {gateway.owner || 'NA'}
                                    </p>
                                    <p style={{ fontSize: 12, color: '#0d3152' }}>
                                      <strong>Position:</strong> {gateway.position || 'NA'}
                                    </p>
                                    <p style={{ fontSize: 12, color: '#0d3152' }}>
                                      <strong>Status:</strong> {gateway.owner === 'Moko' ? statussMoko[gateway.device_id]?.status || 'offline' : statuss[gateway.device_id]?.status || 'offline'}
                                    </p>
                                    <p style={{ fontSize: 12, color: '#0d3152' }}>
                                      <strong>Connected Asset:</strong>{' '}
                                      <span
                                        style={{ color: 'green', fontSize: '14px', fontWeight: 'normal', textDecoration: 'underline', cursor: 'pointer' }}
                                        onClick={() => handleBeaconModal(gateway.connected_assets, gateway.device_id)}
                                      >
                                        {gateway.connected_assets?.length}
                                      </span>
                                    </p>
                                    <p style={{ fontSize: 12, color: '#0d3152' }}>
                                      <strong>Last Updated:</strong>{' '}
                                      <span style={{ fontWeight: 500 }}>
                                        {
                                          gateway.owner === 'Moko'
                                            ? new Date(statussMoko[gateway.device_id]?.ts).toLocaleString()
                                            : new Date(gatewaystatus[gateway.device_id]?.ts).toLocaleString()
                                        }
                                      </span>
                                    </p>
                                  </Box>
                                </Box>
                              ))
                            }
                          </Box>
                        </Grid>
                      </Grid>
                    )
                  })
                }
              </Grid>
            </Grid>

            <Modal
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
            >
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",

                  width: isMobile ? 300 : 700,
                  maxHeight: "100%",

                  overflowY: "auto",
                  overflowX: "auto",
                  backgroundColor: "white",
                  boxShadow: 24,
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "flex-end",
                    cursor: "pointer",
                    padding: "20px",

                  }}
                  onClick={handleCloseModal}
                >
                  <img style={{ width: 20, height: 20 }} src="/Close.png" />
                </div>
                {
                  props.filter == 'default' && <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap : isMobile ?  "wrap" : "",
                      padding: 1,
                      width: isMobile ? "100%" : 200,
                    }}
                  >

                    {Object.entries({
                      "strongest": "#00FF00",
                      "strong": "#32CD32",
                      "moderate": "#FFFF00",
                      "weak": "#FFA500",
                      "weakest": "#FF0000",
                      "single": "#FFFFFF",
                    }).map(([strength, color]) => (
                      <Box key={strength} sx={{ display: 'flex', alignItems: 'center', mb: 1, mr: 2 }}>
                        <Box
                          sx={{
                            width: 30,
                            height: 10,
                            backgroundColor: color,
                            mr: 1,
                            border: 0.1
                          }}
                        />
                        <Typography variant="body2">{strength.charAt(0).toUpperCase() + strength.slice(1)}</Typography>
                      </Box>
                    ))}
                  </Box>}

                {
                  props.filter == 'default' ?
                    <Box
                      sx={{
      
                        "& .row-32CD32": {
                          bgcolor: "#32CD32",
                          "&:hover": {
                            bgcolor: "#32CD32",
                          }
                        },
                        "& .row-FFA500": {
                          bgcolor: "#FFA500",
                          "&:hover": {
                            bgcolor: "#FFA500",
                          }
                        },
                        "& .row-00FF00": {
                          bgcolor: "#00FF00",
                          "&:hover": {
                            bgcolor: "#00FF00",
                          }
                        },
                        "& .row-FFFF00": {
                          bgcolor: "#FFFF00",
                          "&:hover": {
                            bgcolor: "#FFFF00",
                          }
                        },
                        "& .row-FF0000": {
                          bgcolor: "#FF0000",
                          "&:hover": {
                            bgcolor: "#FF0000",
                          }
                        },
                        "& .row-default": {
                          bgcolor: "transparent",
                          "&:hover": {
                            bgcolor: "transparent",
                          }
                        },
                      }}
                    >
                      <DataGrid
                        getRowId={(row) => row.mac_id}
                        rows={data}
                        columns={columns}
                        pageSize={10}
                        rowSelection={false}
                        rowsPerPageOptions={[10, 20, 30]}
                        components={{
                          Toolbar: GridToolbar,
                          FilterPanel: GridFilterPanel,
                        }}
                        slotProps={{
                          filterPanel: {
                            sx: {
                              width: "100%",          // full width responsive
                              maxWidth: "100%",
                              padding: "10px",
                              "& .MuiDataGrid-filterForm": {
                                flexDirection: "column",
                                gap: "10px",
                              },
                            },
                          },
                        }}
                        pagination
                        getRowClassName={(params) => {
                          const colorCode = strength[params.row.mac_id];
                          return colorCode ? `row-${colorCode.replace('#', '')}` : 'row-default';
                        }}
                      />
                    </Box>
                    :
                    <DataGrid
                      getRowId={(row) => row.mac_id}
                      rows={data}
                      columns={columns}
                      rowSelection={false}
                      pageSize={10}
                      rowsPerPageOptions={[10, 20, 30]}
                      components={{
                        Toolbar: GridToolbar,
                        FilterPanel: GridFilterPanel,
                      }}
                      slotProps={{
                        filterPanel: {
                          sx: {
                            width: "100%",          // full width responsive
                            maxWidth: "100%",
                            padding: "10px",
                            "& .MuiDataGrid-filterForm": {
                              flexDirection: "column",
                              gap: "10px",
                            },
                          },
                        },
                      }}
                      pagination
                    />
                }




              </div>
            </Modal>

          </div> :
          <Grid container spacing={2} alignItems="center"><Box display="flex" justifyContent="center" alignItems="center" height="10vh">

            <CircularProgress size={28} />
          </Box></Grid>
      }


    </>

  );
};

export default AssetGraph;
